import React from 'react';
import TopPanel from "../toppanel.js";
import CheckListView from "../checklists/checklistview.js";

module.exports = React.createClass({
    componentWillMount: function() {
        HC_CheckLoginAndAcc(this, HC_SA);
    },
    componentDidMount: function() {
        HC_RestoreNavPanel();
        HC_SelectNavItem("li-administrate");
        this.loadFromServer();
        HC_SubscribeHammerEvent(this.refs.hc_user_content, "swiperight", this.goBack);
        HC_SubscribeHammerEvent(this.refs.hc_payment_plans, "swiperight", HC_ToggleNavPanel);

        $('#hc-pay-plan-price-input').keypress(function(event) {
            if(event.which < 46
                || event.which > 59) {
                event.preventDefault();
                return;
            }
            if(event.which == 46 && $(this).val().indexOf('.') != -1)
                event.preventDefault();

        });
    },
    componentWillUnmount: function() {
        HC_UnsubscribeHammerEvent(this.refs.hc_user_content, "swiperight");
        HC_UnsubscribeHammerEvent(this.refs.hc_payment_plans, "swiperight");
    },

    successRequest: function(reply) {
        if (this.state.needGoBack)
            this.goBack();
        this.state.commandCounter--;
        if (this.state.commandCounter == 0) { // don't update model is there're other commands in queue
            if (this.state.selectFirst)
                this.state.selectedId = null;
            this.state.changes = {};
            HC_SetDataAndSelectedItem(this, reply.data, {needGoBack: false });
        }
    },
    successSARequest: function(reply) {
        this.setState({max_users: reply.data.max_users, max_lists: reply.data.max_lists});
    },

    errorCreateRequest: function (code, errorString) {
        this.state.commandCounter--;
        if (code == 409 && errorString.indexOf("DUPLICATED_EMAIL") >= 0) {
            HC_Validate();
        }
        else
            HC_SetError(code, errorString);
    },
    loadFromServer: function() {
        this.state.commandCounter++;
        HC_SendRequest("payment_plans", null, this.successRequest, null);
        HC_SendRequest("get_sa_settings", null, this.successSARequest, null);
    },
    getInitialState: function() {
        return {
            data: [],
            selectedId: null,
            needGoBack: false,
            commandCounter: 0,
            afterFailState: false,
            selectFirst: false,
            changes: {},

            createMode: false,
            max_lists: 0,
            max_users: 0
        };
    },

    handleOnSelected: function(e, createNew=false) {
        var itemId = parseInt($(e.target).closest(".hc-list-view-item").attr('data-key'));
        var state = {selectedId: itemId, changes: {}, afterFailState: false};
        if (itemId != this.state.selectedId) {
            state.createMode = false;
            if (this.state.data.length > 0 && this.state.data[0].id == -1)
                this.state.data.shift();  // remove fake New User item
        }
        if (createNew == true)
            state.createMode = true;
        if (HC_DeviceType() == HC_CONST.SCR_PHONE) {
            this.setState(state);
            HC_SwitchRPanel();
        } else
            this.setState(state);
        HC_Validate(null, true);
    },

    onFieldChanged: function(o) {
        var dkey = o.target.getAttribute('data-key');
        var val = o.target.value;
        if (dkey == "amount") {
            if (val.indexOf(".") != '-1') {
                o.target = o.target.value.substring(0, o.target.value.indexOf(".") + 3);
                val = o.target;
            }
        }
        this.state.changes[dkey] = val;
        this.setState({changes: this.state.changes});
    },

    goBack: function() {
        HC_RestoreRPanel();
        if (this.state.data.length > 0 && this.state.data[0].id == -1) {
            this.state.data.shift();  // remove fake New User item
            this.state.selectedId = this.state.data.length > 0 ? this.state.data[0].id : null;
        }
        this.setState({createMode: false, password: '', afterFailState:false});
    },


    handlePlanCreated: function() {
        if (!HC_Validate())
            return;

        var data = this.state.changes;
        data.is_new = true;
        if (data.amount)
            data['amount'] = data['amount'] * 100;

        this.state.needGoBack = true;
        this.state.commandCounter++;
        HC_SendRequest("add_payment_plan", data, this.successRequest, this.errorCreatePlanRequest);
    },

    handlePlanUpdated: function(o) {
        if (!HC_Validate())
            return;
        var id = parseInt(this.state.selectedId);
        if (id) {
            var item = HC_CurrentItem(this);
            if (item.id != id)
                return;
            var data = item;
            data.is_new = false;
            data.id = id;

            var changes = this.state.changes;
            for(var key in changes)
                data[key] = changes[key]
            if (changes.amount)
                data['amount'] = data['amount'] * 100;

            //limits
            if (item.is_trial) {
                data['max_users'] = changes.max_users ? changes.max_users : this.state.max_users;
                data['max_lists'] = changes.max_lists ? changes.max_lists : this.state.max_lists;
                HC_SendRequest("set_sa_settings", data, this.successSARequest, null);
            }
            this.state.commandCounter++;
            HC_SendRequest("add_payment_plan", data, this.successRequest, null);
        }
    },

    handleCreateNew: function() {
        if (this.state.selectedId == -1)
            return;
        this.handleOnSelected(this.state.selectedId, true);
        this.state.data.unshift({id: -1, name: "", is_visible: false, description: '', amount: '', currency: "empty", period: "empty"});
        this.setState({data: this.state.data, selectedId: -1, afterFailState: false, selectFirst:true, createMode: true });
    },

    planBoolFieldChanged: function(o) {
        var key = o.target.getAttribute('data-key');
        if (this.state.changes[key] == undefined & !this.state.createMode)
            this.state.changes[key] = !HC_CurrentItem(this)[key];
        else
            this.state.changes[key] = !this.state.changes[key];
        this.setState({changes: this.state.changes});
    },

    ensureGlobalValidationFunctionsCreated: function (o) {
        if (window.HC_PLAN_VALIDATION != this) {
            window.HC_PLAN_VALIDATION = this;

            window.HC_SignupValidation_Select = function (str) {
                return (str !== HC_LANG.SU_CHOOSE ? [true, ""] : [false, HC_LANG.SU_FIELD_DONT_EMPTY])
            };

            window.HC_PlanValidation_Price = function(str) {
                var number = parseFloat(str);
                if (number <= 0)
                    return [false, "The price must be more than zero"];
                return [true, ""];
            }.bind(this);
        }
    },

    render: function() {
        this.ensureGlobalValidationFunctionsCreated();
        var deviceType = HC_DeviceType();
        var licon = '', liconAction = null;
        if (deviceType == HC_CONST.SCR_PHONE || this.state.createMode) {
            licon = 'fa-angle-left';
            liconAction = this.goBack;
        }
        var ricon = ""; //"fa-trash-o";
        var riconAction = null;


        //styles
        var captionDivStyle = {display: "inline-block", marginRight:"3%", paddingTop:"0.2rem"};
        captionDivStyle.flex = captionDivStyle.WebkitFlex = "0 1 8rem";
        var captionDivRightStyle = {display: "inline-block", marginRight:"1%", marginLeft:"1%", flex: "0 1 10rem", paddingTop:"0.2rem" };
        captionDivRightStyle.flex = captionDivRightStyle.WebkitFlex = "0 1 10rem";

        var labelStyle = {padding:"1% 2% 0%", display: "flex"};
        labelStyle.flexFlow = labelStyle.WebkitFlexFlow = "row wrap";

        var div60 = {display: "inline-block", width: "60%", paddingTop:"0.2rem"};
        div60.flex = div60.WebkitFlex = "1 1 150px";
        div60.maxWidth = "300px";
        var div100Right = {display: "inline-block", width: "60%", maxWidth: "300px", marginBottom:"0"};
        div100Right.flex = div100Right.WebkitFlex = "1 1 200px";

        var updateBtnStyle = {marginTop:"1rem", marginBottom:"1rem"};
        var errorDivStyle = {display: 'none'};

        // payment menu
        var i = 0;
        var items = this.state.data.map(function(o){
            var itemClass = "hc-list-view-item hc-f3";
            if (o.id === this.state.selectedId)
                itemClass += " hc-active-item";
            return (
                <div data-key={o.id} key={++i} className={itemClass} style={{padding: "20px", height:"70px", cursor:"pointer"}} onClick={this.handleOnSelected}>
                    <span data-key={o}>{o.name}</span>
                    <span className="hc-f-l hc-f4" style={{float:'right'}}>{o.currency}</span>
                </div>
            );
        }.bind(this));

        var planPeriods = [];
        planPeriods.push(<option key={0} value="Choose">Choose</option>);
        planPeriods.push(<option key={1} value={(1 + "|m")}>1 month</option>);
        for(var i = 2; i < 13; i++)
            planPeriods.push(<option key={i} value={(i + "|m")}>{i} months </option>)

        // selected item
        var item = HC_CurrentItem(this);
        var changes = this.state.changes;
        var name, isPlanActive, planDesc, planPrice, planPeriod, text, currencyStr;

        if (this.state.createMode) {
            ricon = "fa-floppy-o hc-fa-action";
            riconAction = this.handlePlanCreated;
            text = "New plan";
            updateBtnStyle.display = "none";
        }

        if (item == null) {
            isPlanActive = "";
            planDesc = "";
            planPrice = "";
            currencyStr = "empty";
            planPeriod = "1|m";
            ricon = "";
            riconAction = null;
            name = "";
        }
        else {
            text = item.name;
            name = changes.name != undefined ? changes.name : item.name;
            isPlanActive = changes.is_visible != undefined ? changes.is_visible : item.is_visible;
            currencyStr = changes.currency != undefined ? changes.currency : item.currency;
            planDesc = changes.description != undefined ? changes.description : item.description;
            planPrice = changes.amount != undefined ? changes.amount : item.amount / 100.0;

            var periodStr = item.period.split('|');
            planPeriod = changes.period != undefined ? changes.period : ((periodStr[1] == "y") ? "12|m" : item.period)
        }

        // plan status
        var statusBtnLeftStyle = {width: "50%", display: "inline-block", textAlign: "center", borderRadius:"5px 0 0 5px" };
        var statusBtnRgtStyle = {width: "50%", display: "inline-block", textAlign: "center", borderRadius:"0 5px 5px 0" };

        statusBtnLeftStyle.backgroundColor = isPlanActive ? "#e9f6f4": "#fff";
        statusBtnRgtStyle.backgroundColor = isPlanActive ? "#fff" : "#e9f6f4";
        statusBtnLeftStyle.color = isPlanActive ? "#30ae97" : "#8a8d91";
        statusBtnRgtStyle.color = isPlanActive ? "#8a8d91": "#30ae97";
        if (isPlanActive)
            statusBtnLeftStyle.border = "solid 1px #1cb097";
        else
            statusBtnRgtStyle.border = "solid 1px #1cb097";

        var classBtn = "hc-button";
        var opts = {};
        if ($.isEmptyObject(this.state.changes)) {
            classBtn += ' hc-button-off';
            opts['disabled'] = 'disabled';
        }

        // limits
        var limits, max_users, max_lists, trialOpt = {} ;
        if (item != null && item.is_trial) {
            max_users = changes.max_users ? changes.max_users : this.state.max_users;
            max_lists = changes.max_lists ? changes.max_lists : this.state.max_lists;
            trialOpt['disabled'] = 'disabled';
            planPrice = "Free";

            limits = (
                <div>
                    <div className="hc-flex-display" style={labelStyle}>
                        <div id="hc-pay-plan-user-count" style={captionDivRightStyle} className="hc-f4 hc-f-l">Max Users</div>
                        <div style={div100Right}>
                            <input type="number" className="form-control hc-f4 hc-f-l hc-validated" data-key="max_users" onChange={this.onFieldChanged} value={max_users}
                                   data-vfunc="HC_ValidateNotEmptyField" data-vtext="hc-pay-plan-user-count-error" data-vcaption="hc-pay-plan-user-count" />
                            <div id="hc-pay-plan-user-count-error" style={errorDivStyle}/>
                        </div>
                    </div>
                    <div className="hc-flex-display" style={labelStyle}>
                        <div id="hc-pay-plan-list-count" style={captionDivRightStyle} className="hc-f4 hc-f-l">Max Checklists</div>
                        <div style={div100Right}>
                            <input type="number" className="form-control hc-f4 hc-f-l hc-validated" data-key="max_lists" onChange={this.onFieldChanged} value={max_lists}
                                   data-vfunc="HC_ValidateNotEmptyField" data-vtext="hc-pay-plan-user-list-error" data-vcaption="hc-pay-plan-list-count" />
                            <div id="hc-pay-plan-list-count-error" style={errorDivStyle}/>
                        </div>
                    </div>
                </div>
            )
        }
        return (
            <div id="panel-checklists" style={{height:"100%"}}>
                <div className="hc-list-panel hc-br">
                    <TopPanel text="Payment plans" ricon="fa-plus-circle" licon="fa-bars"
                              onLiconClick={HC_ToggleNavPanel} onRiconClick={this.handleCreateNew}/>
                    <div ref="hc_payment_plans" style={{height: "100%", overflowY: "auto"}} >
                        {items}
                    </div>
                </div>

                <div ref="hc_user_content" className="hc-content-panel">
                    <div className="hc-internal-panel">
                        <TopPanel text={text} licon={licon} onLiconClick={liconAction} ricon={ricon}  onRiconClick={riconAction}/>
                        <div style={{top:"60px", bottom:0, width:"100%", overflowY:"auto", WebkitOverflowScrolling:'touch', overflowX:"hidden", marginTop:"2%"}}>

                            <div className="hc-flex-display" style={labelStyle}>
                                <div id="hc-pay-plan-name" style={captionDivRightStyle} className="hc-f4 hc-f-l">{HC_LANG.CHL_NAME}</div>
                                <div style={div100Right}>
                                    <input className="form-control hc-f4 hc-f-l hc-validated" data-key="name" onChange={this.onFieldChanged} value={name}
                                           data-vfunc="HC_ValidateNotEmptyField" data-vtext="hc-pay-name-error" data-vcaption="hc-pay-plan-name" />
                                    <div id="hc-pay-name-error" style={errorDivStyle}/>
                                </div>
                            </div>

                            <div className="hc-flex-display" style={labelStyle}>
                                <div style={captionDivRightStyle} className="hc-f4 hc-f-l">Status</div>
                                <div style={div100Right}>
                                    <input type="button" className="form-control hc-f4" style={statusBtnLeftStyle}
                                           data-key="is_visible" onClick={this.planBoolFieldChanged} value="Active" />

                                    <input type="button" className="form-control hc-f4" style={statusBtnRgtStyle}
                                           data-key="is_visible" onClick={this.planBoolFieldChanged} value="Inactive" />
                                </div>
                            </div>

                            <div className="hc-flex-display" style={labelStyle}>
                                <div id="hc-pay-plan-desc" style={captionDivRightStyle} className="hc-f4 hc-f-l">Description</div>
                                <div style={div100Right}>
                                    <input className="form-control hc-f4 hc-f-l hc-validated" data-key="description" onChange={this.onFieldChanged} value={planDesc}
                                           data-vfunc="HC_ValidateNotEmptyField" data-vtext="hc-pay-desc-error" data-vcaption="hc-pay-plan-desc"/>
                                    <div id="hc-pay-desc-error" style={errorDivStyle}/>
                                </div>
                            </div>

                            <div className="hc-flex-display" style={labelStyle}>
                                <div id="hc-pay-plan-price" style={captionDivRightStyle} className="hc-f4 hc-f-l">Price</div>
                                <div style={div100Right}>
                                    <select className="form-control hc-f4 hc-f-l hc-validated" {...trialOpt} data-key="currency" style={{width: "35%", display: "inline"}} onChange={this.onFieldChanged} value={currencyStr}
                                            data-vfunc="HC_SignupValidation_Select" data-vtext="hc-pay-curr-error" data-vcaption="hc-pay-plan-price">
                                        <option value={"Choose"}>Choose</option>
                                        <option value={"eur"}>€</option>
                                        <option value={"usd"}>$</option>
                                    </select>
                                    <input id="hc-pay-plan-price-input" className="form-control hc-f4 hc-f-l hc-validated" {...trialOpt} data-key="amount" onChange={this.onFieldChanged} value={planPrice}
                                           style={{width: "63%", marginLeft:"2%", display: "inline"}}
                                           data-vfunc="HC_PlanValidation_Price" data-vtext="hc-pay-price-error" data-vcaption="hc-pay-plan-price"/>
                                    <div id="hc-pay-curr-error" style={errorDivStyle}/>
                                    <div id="hc-pay-price-error" style={errorDivStyle}/>
                                </div>
                            </div>

                            <div className="hc-flex-display" style={labelStyle}>
                                <div id="hc-pay-plan-period" style={captionDivRightStyle} className="hc-f4 hc-f-l">Period</div>
                                <div style={div100Right}>
                                    <select className="form-control hc-f4 hc-f-l hc-validated" {...trialOpt} data-key="period" onChange={this.onFieldChanged} value={planPeriod}
                                            data-vfunc="HC_SignupValidation_Select" data-vtext="hc-pay-period-error" data-vcaption="hc-pay-plan-period" >
                                        {planPeriods}
                                    </select>
                                    <div id="hc-pay-period-error" style={errorDivStyle}/>
                                </div>
                            </div>

                            {limits}

                            <div className="hc-flex-display" style={labelStyle}>
                                <div style={captionDivRightStyle} className="hc-f4 hc-f-l"> </div>
                                <div style={div100Right}>
                                    <button className={classBtn} onClick={this.handlePlanUpdated} {...opts}
                                            style={updateBtnStyle}>
                                        Update
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
});




// WEBPACK FOOTER //
// ./payments/payment_plans.js